import { Component, Input } from "@angular/core";

@Component({
    selector: "mobi-office-lib-dynamic-mat-columns",
    templateUrl: "./dynamic-mat-columns.component.html",
    styleUrls: ["./dynamic-mat-columns.component.scss"],
    standalone: false
})
export class DynamicMatColumnsComponent {
  constructor() {}

  @Input() row!: any;
  @Input() item!: any;
}
